import React from "react";

function InspectionHelpLine() {
  return (
    <div className="white-text">
      <p>Inspection helpline</p>
      <p className="grey-text text-lighten-1 valign-wrapper">
        <span className="material-icons-outlined font-16px white-text">call</span> +91
        765414568
      </p>
      <p
        className="grey-text text-lighten-1 valign-wrapper"
        style={{ marginTop: "-5px" }}
      >
        <span
          className="material-icons-outlined font-16px white-text"
          style={{ marginRight: "5px" }}
        >
          email
        </span>
        auction@cerclex.com
      </p>
    </div>
  );
}

export default InspectionHelpLine;
